import { goRequest } from '../utils/httpClientTs';

export const getReciprocityTypes = () => {
  return goRequest({
    url: `/api/resources/reciprocity/types`,
    method: 'GET',
  });
};

export const getIntlCommittees = (data) => {
  return goRequest({
    url: `/membership/international/standing_committees`,
    method: 'GET',
  });
};

export const getIntlAppointments = (data) => {
  return goRequest({
    url: `/membership/international/standing_appointments`,
    method: 'GET',
  });
};

export const getIntlBoard = (data) => {
  return goRequest({
    url: `/membership/international/board_of_directors`,
    method: 'GET',
  });
};

export const sendCommitteeMessage = (data) => {
  return goRequest({
    url: `/membership/international/committees/messages`,
    method: 'POST',
    data: data,
  });
};
